import { Hidden } from 'braid-design-system';

type CareerFeedMobileWebFeatureFlagContainerProps = {
  mobileView: React.ReactNode;
  tabletAndAboveView: React.ReactNode;
};

export const CareerFeedMobileWebFeatureFlagContainer: React.FC<
  CareerFeedMobileWebFeatureFlagContainerProps
> = ({ mobileView, tabletAndAboveView }) => (
  <>
    <Hidden above="mobile">{mobileView}</Hidden>
    <Hidden below="tablet">{tabletAndAboveView}</Hidden>
  </>
);
